module.exports = __webpack_public_path__ + "img/caiji-type-1-1.288c328f.png";